/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Endedreason1Inputs */

const de__field_endedreason1 = /** @type {(inputs: _Field_Endedreason1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendigungsgrund`)
};

/**

* @param {_Field_Endedreason1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_endedreason1 = /** @type {((inputs?: _Field_Endedreason1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Endedreason1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_endedreason1(inputs)
});
export { _field_endedreason1 as "_field_endedReason" }